import { Component, Directive, Input } from "@angular/core";

import { ConfigurationProvider } from '../../providers/providers';

@Component({
  selector: 'info-fab',
  template: ''
  // template: `
  //   <ion-fab top right>
  //     <button ion-fab mini color="secondary" (click)="doShowInfo()">
  //       <ion-icon name="information"></ion-icon>
  //     </button>
  //   </ion-fab>
  // `
})
@Directive({
  selector: "info-fab"
})
export class InfoFab {
  @Input('title') title: string;

  items = [
    { 
      title: 'Daily Nutrition',
      content: '<p>Log your bodyweight and food/meals for each day to track total nutrients for that day.</p>'
    },
    { 
      title: 'Daily Activity', 
      content: `<p>Log your daily exercise or activities.</p>` 
    },
    { 
      title: 'Food Inventory', 
      content: `<p>The food inventory contains individual food items for a single serving, which would give the most accurate nutrient profile.</p>
        <p>A food item can also be an entire entree or estimate of a meal (where you don't know all of the ingredients).</p>
        <p>Examples: A burrito or cheeseburger from a restaurant</p>` 
    },
    { 
      title: 'Meals',
      content: `<p>Meals are a combination of one or more food items. Each food item in a meal is based on a serving of that item.</p>
        <p>Examples: 1 egg, 1/2 serving avocado, 2 servings ham.</p>`
    },
    { 
      title: 'Food Plan',
      content: '<p>Create a food plan for an entire day\'s worth of food to plan meals and calculate nutrients.</p>'
    },
    { 
      title: 'Activities',
      content: `<p>Add individual activities for exercise or general fitness.</p>
        <p>Examples: Push-ups, squats, jumping jacks.</p>`
    },
    { 
      title: 'Routines',
      content: `<p>Create a routine of multiple activities that can be followed as a plan.</p>`
    },
    { 
      title: 'Memos',
      content: '<p>Create a memo for anything you want; a shopping list, exercise routines, or just notes to yourself.</p>'
    }
  ];

  constructor(
    private config: ConfigurationProvider) {
  }

  doShowInfo() {
    const item = this.items.find(x => x.title === this.title);
    this.config.showAlert(item.title, item.content);
  }

}


// WEBPACK FOOTER //
// ./src/components/info-fab/info-fab.ts